import React, { useState } from "react";

import HttpManager from "../../services/HttpManager";

/**
 * Dónde va la firma de un contrato (Esteban, 2026-10-16: una sola verdad en la solicitud, el perfil y Matrículas → Contratos).
 * Mientras no está firmado: Copiar Enlace y Enviar / Reenviar por WhatsApp (sale por un número de Ventas; al firmar le llega
 * su copia). Firmado: quién y cuándo.
 */
export interface FirmaResumenDTO {
	contratoId: number;
	campusId: number;
	estado: string;
	estadoNombre: string;
	detalle: string | null;
	enlace: string | null;
	puedeEnviar?: boolean;
}

const FIRMADO = ["firmado", "firmado_papel"];

/** Copia al portapapeles; sin permiso (o fuera de HTTPS) prueba a la antigua. */
const copiarTexto = async (t: string): Promise<boolean> => {
	try {
		await navigator.clipboard.writeText(t);
		return true;
	} catch (e) {
		const area = document.createElement("textarea");
		area.value = t;
		area.style.position = "fixed";
		area.style.opacity = "0";
		document.body.appendChild(area);
		area.select();
		let ok = false;
		try { ok = document.execCommand("copy"); } catch (x) { ok = false; }
		document.body.removeChild(area);
		return ok;
	}
};

const errorDe = (e: any): string => e?.response?.data?.error || e?.response?.data?.message || "No se pudo. Intenta otra vez.";

const FirmaEstado = ({ firma, soloLectura, onCambio }: { firma: FirmaResumenDTO | null | undefined; soloLectura?: boolean; onCambio?: () => void }) => {
	const [ocupado, setOcupado] = useState(false);
	const [aviso, setAviso] = useState<string | null>(null);
	const [enlaceVisible, setEnlaceVisible] = useState<string | null>(null);
	if (!firma) {
		return null;
	}
	const http = HttpManager.getInstance();
	const firmado = FIRMADO.includes(firma.estado);
	const color = firmado ? "var(--wa-tinta)" : (firma.estado === "error" || firma.estado === "revisar" ? "var(--wa-oro)" : "var(--wa-apagado)");

	const copiar = async () => {
		setAviso(null);
		setOcupado(true);
		try {
			const enlace = firma.enlace || (await http.enrollmentRequestsService.enlaceContratoFirma(firma.campusId, firma.contratoId)).data.enlace;
			if (await copiarTexto(enlace)) {
				setAviso("Enlace copiado. Pégalo en el WhatsApp del cliente.");
			} else {
				setEnlaceVisible(enlace);
			}
		} catch (e) {
			setAviso(errorDe(e));
		} finally {
			setOcupado(false);
		}
	};

	const enviar = async () => {
		setAviso(null);
		setOcupado(true);
		try {
			const r = await http.enrollmentRequestsService.enviarContratoFirma(firma.campusId, firma.contratoId);
			setAviso(r.data.ok ? "Listo: le llegó por WhatsApp para firmarlo." : (r.data.error || "No se pudo mandar."));
			if (onCambio) onCambio();
		} catch (e) {
			setAviso(errorDe(e));
		} finally {
			setOcupado(false);
		}
	};

	const yaSalio = ["enviado", "visto"].includes(firma.estado);
	return (
		<div style={{ fontSize: 13, display: "flex", flexWrap: "wrap", alignItems: "center", gap: "2px 12px", minWidth: 0 }}>
			<span style={{ color, minWidth: 0, overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }} title={firma.detalle || undefined}>
				{"Firma: " + firma.estadoNombre + (firma.detalle ? " · " + firma.detalle : "")}
			</span>
			{!firmado && !soloLectura && firma.puedeEnviar !== false ? (
				<span style={{ display: "flex", gap: 12, marginLeft: "auto" }}>
					<button type="button" className="btn btn-link btn-sm" style={{ padding: 0, fontSize: 13 }} disabled={ocupado} onClick={copiar}>Copiar Enlace</button>
					<button type="button" className="btn btn-link btn-sm" style={{ padding: 0, fontSize: 13 }} disabled={ocupado} onClick={enviar}>{yaSalio ? "Reenviar" : "Enviar para Firmar"}</button>
				</span>
			) : null}
			{aviso ? <div style={{ width: "100%", color: "var(--wa-apagado)" }}>{aviso}</div> : null}
			{enlaceVisible ? <input readOnly value={enlaceVisible} onFocus={(e) => e.target.select()} style={{ width: "100%", fontSize: 12 }} aria-label="Enlace de firma" /> : null}
		</div>
	);
};

export default FirmaEstado;
